module.exports = __webpack_public_path__ + "img/1513403168.771140c2.jpg";